import React from 'react';
import BikeValuationModal from '../Modals/BikeValuationModal';
import ChangeStatusModal from '../Modals/ChangeStatusModal';
import AssignLeadModal from '../Modals/AssignLeadModal';
import SendEmailModal from '../Modals/SendEmailModal';
import SendSMSModal from '../Modals/SendSMSModal';
import CustomerRejectedModal from '../Modals/CustomerRejectedModal';
import BlemishReport from '../Lead_profile_blemish_report';
import TransportModal from '../Modals/TransportModalViews/TransportModal';
import HpiCheckModal from '../Modals/HpiCheckModal';
import CancellCollectionModal from '../Modals/CancellCollectionModal';

export const LeadProfileModals = (props) => {
    switch (props.popup_type) {
    case 'Value Bike (Trade)':
    case 'Value Bike':
    case 'Update Price':
    case 'Update Valuation':
    case 'Update Valuation (Trade)':
        return <BikeValuationModal {...props} isTrade={props.popup_type === 'Value Bike (Trade)' || props.popup_type === 'Update Valuation (Trade)'} />;
    case 'Change Status':
        return <ChangeStatusModal {...props} />;
    case 'Assign Lead':
        return <AssignLeadModal {...props} />;
    case 'Send Email':
        return <SendEmailModal {...props} />;
    case 'Send SMS':
        return <SendSMSModal {...props} />;
    case 'Customer Declined':
        return <CustomerRejectedModal {...props} />;
    case 'Start Blemish Report':
        return <BlemishReport {...props} />;
    case 'Book Collection':
    case 'Re-Book Collection':
    case 'Update Booking':
        return <TransportModal {...props} />;
    case 'HPI Check':
    case 'Redo HPI Check':
        return <HpiCheckModal {...props} />;
    case 'Cancel Collection':
    case 'Cancel Collection (Trade)':
        return <CancellCollectionModal {...props} />;
    default:
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/LeadProfileModals.js